<template>

  <router-view/>
</template>
<script setup>
import {watch} from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import router from "@/router";
const route=useRoute()

watch(route,(to,from)=>{
  // console.log(to.name,to.path)
  document.title = '厨具用能计量平台';

  if(sessionStorage.getItem("currentUser") === null){
    router.push("/login")
    return
  }

  if(to.name=='个人中心'){
    let obj={
      name:to.name,
      path:to.path
    }
    store.commit('ADD_TABS',obj)
  }

  // 这里是刷新后的逻辑
  if(to.name == undefined){
    router.push("/index")
  }

},{deep:true,immediate:true})



</script>
<!--调整增幅页面占比-->
<style>
html,body,#app{
  height: 100%;
}

.app-container{
  padding:20px
}
</style>
